import { useEffect } from "react"
import { metadata, TEXT_BUTTON } from "lacinetek-common/src/metadata"

import { useModal } from "lib/modal"
import { useTranslation } from "lib/i18n/translation"

import { BlockOverlay } from "components/modals/svod/block-overlay"
import { BlockHeaderSquare } from "./block-header-square"
import { BlockTitle } from "./block-title"
import { BlockQuote } from "./block-quote"
import { DisplaySliders } from "./slider"
import { BlockText } from "./block-text"

export const Square = ({ block,  className, overlayAuto }) => {
	const { c } = useTranslation()
	const { show } = useModal()

	const handleSquareModal = (event, block) => {
		event.preventDefault()
		show({
			id: "block-overlay",
			children: <BlockOverlay block={block} />,
			className: "is-archive modal stackable"
		})
	}

	useEffect(() => {
		if (overlayAuto) {
			show({
				id: "thematic-overlay",
				children: <BlockOverlay block={block} />,
				className: "is-archive modal stackable"
			})
		}
	}, [])

	return (
		<section id={block.id} className={className}>
			<BlockTitle block={block} />
			<BlockHeaderSquare block={block} />
			<BlockQuote block={block} />
			<DisplaySliders rails={block.children.items} />
			{
				metadata(block, TEXT_BUTTON)
				&& <p className="section-link centered">
					<a
						href="#"
						rel="nofollow noopener"
						title={c("see-all-articles")}
						className="button"
						onClick={event => handleSquareModal(event, block)}
					>
						{metadata(block, TEXT_BUTTON)}
					</a>
				</p>
			}
		</section>
	)
}
